export class CaseCreation {
  caseNo: number;
  clientId: number;
  siteId: number;
  caseReceivedDate: Date;
  caseInitiationDate: Date;
  urlName: string;
  autoAssign: boolean;
  loggedIn: number;
  invitationFlag: boolean;
  caseEntry: CaseEntry[] = [];
  clientName: string;
  candidateName: string;
  siteName: string;
  clientReferenceNo: string;
  applicantId: string;
  loaStatus: string;
  siteNo: string;
  screeningOwnerId: number;
  deptId: number;
  teamId: number;
  userName: string;
  chargeCode: string;
  invitationId: number;
  applicationId: number;
  companySiteVisitFlag: boolean;
  packageId?: number;
  caseComponent?: any[] = [];
  // packCompList?: any[] = [];
  // indComponentList?: any[] = [];
  // preComponentList?: any[] = [];
}
export class CaseEntry {
  applicantId: string;
  candidateFirstName: string;
  candidateMiddleName: string;
  candidateLastName: string;
  clientReferenceNo: string;
  caseRefNo: string;
  casePriorityLookupId?: number;   
  countryId?:number;
  employeeId :string;
  candidateId = 0;
  screeningOwnerId?: number;
  contactId: number;
  chargeCode: string;
  clientName: string;
  siteName: string;
  tat: number;
  caseNo: number;
  invitationExpiryLookupId: number;
  phoneNo?: string;
  emailId: string;
  consentLookupId: number;
  remarks?: string;
  packageId?: number;
  caseComponent?: any[] = [];
  packCompList?: any[] = [];
  indComponentList?: any[] = [];
  preComponentList?: any[] = [];
}
